<div class="aib-root" [class.aib-root--labelled]="labelled" *ngIf="items.length > 0">
  <button
    type="button"
    class="aib-trigger"
    [class.aib-trigger--active]="open"
    (click)="toggle()"
    [matTooltip]="'ANNOUNCEMENT.WHATS_NEW.HEADER_TOOLTIP' | translate"
    [attr.aria-label]="'ANNOUNCEMENT.WHATS_NEW.HEADER_TOOLTIP' | translate"
    [attr.aria-expanded]="open"
    aria-haspopup="dialog"
    matTooltipClass="cl-action-tooltip"
    [matTooltipShowDelay]="200"
    matTooltipPosition="below"
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="m3 11 18-5v12L3 14v-3Z" />
      <path d="M11.6 16.8a3 3 0 0 1-5.8-1.6" />
    </svg>
    <span *ngIf="labelled">{{ 'ANNOUNCEMENT.WHATS_NEW.HEADER_TOOLTIP' | translate }}</span>
    <span *ngIf="unreadCount > 0" class="aib-badge">{{ unreadCount > 99 ? "99+" : unreadCount }}</span>
  </button>

  <div class="aib-panel" *ngIf="open" role="dialog" [attr.aria-label]="'ANNOUNCEMENT.WHATS_NEW.TITLE' | translate">
    <header class="aib-panel__header">{{ "ANNOUNCEMENT.WHATS_NEW.TITLE" | translate }}</header>
    <div class="aib-panel__list">
      <button type="button" class="aib-row" *ngFor="let item of items" [class.aib-row--unread]="!item.seen" (click)="openItem(item)">
        <span class="aib-row__dot" *ngIf="!item.seen"></span>
        <span class="aib-row__title">{{ text(item.announcement.title) || item.announcement.slug }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Nothing is rendered here: the announcement is handed to the launcher at the app-frame root,
     which shows it in the style it was authored in. Rendering it from inside the header trapped
     the overlay in the header's stacking context, under the sidebar. -->

